export default __webpack_public_path__ + "static/slide0-a2ab4a312d5d62ba2f1c056408e9b49e.jpg";